/* Lovable Home — Craft ProductStories (variant="craft"): 7 tabs, each a bespoke
   interactive StoryShell visual. DYNAMIC: all content is read from the
   <script type="application/json" data-cr-data> payload rendered by the section.
   Visuals, classes and interactions are unchanged. No framework. */
(function () {
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function arr(x) { return Array.isArray(x) ? x : []; }
  function slug(s) {
    return String(s == null ? '' : s)
      .toLowerCase()
      .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }
  function pick(list, id) { for (var i = 0; i < list.length; i++) { if (list[i].id === id) return list[i]; } return list[0]; }

  // ---- lucide-ish icons (stroke) ----
  var IC = {
    micro: '<path d="M6 18h8"/><path d="M3 22h18"/><path d="M14 22a7 7 0 1 0 0-14h-1"/><path d="M9 14h2"/><path d="M15 9V3a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v6"/>',
    leaf: '<path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z"/><path d="M2 21c0-3 1.85-5.36 5.08-6"/>',
    shield: '<path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/><path d="m9 12 2 2 4-4"/>',
    flask: '<path d="M14 2v6a2 2 0 0 0 .245.96l5.51 10.08A2 2 0 0 1 18 22H6a2 2 0 0 1-1.755-2.96l5.51-10.08A2 2 0 0 0 10 8V2"/><path d="M6.453 15h11.094"/><path d="M8.5 2h7"/>',
    file: '<path d="M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4"/><path d="M14 2v4a2 2 0 0 0 2 2h4"/><path d="m3 15 2 2 4-4"/>',
    dna: '<path d="m10 16 1.5 1.5"/><path d="m14 8-1.5-1.5"/><path d="M15 2c-1.798 1.998-2.518 3.995-2.807 5.993"/><path d="m16.5 10.5 1 1"/><path d="m17 6-2.891-2.891"/><path d="M2 15c6.667-6 13.333 0 20-6"/><path d="m20 9 .891.891"/><path d="M3.109 14.109 4 15"/><path d="m6.5 12.5 1 1"/><path d="m7 18 2.891 2.891"/><path d="M9 22c1.798-1.998 2.518-3.995 2.807-5.993"/>',
    arrow: '<line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>'
  };
  function svg(paths, cls) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="' + (cls || '') + '">' + (paths || '') + '</svg>'; }

  // ---- backdrops ----
  function moleculeBackdrop() {
    return '<svg viewBox="0 0 300 260" class="lvh-cr__bdsvg" style="color:var(--lvp-ink)"><g fill="none" stroke="currentColor" stroke-width="1.4" opacity="0.5"><polygon points="150,60 215,95 215,165 150,200 85,165 85,95"/><polygon points="150,72 207,102 207,158 150,188 93,158 93,102" stroke-dasharray="3 3" opacity="0.6"/><line x1="150" y1="60" x2="150" y2="32"/><line x1="215" y1="95" x2="245" y2="80"/><line x1="215" y1="165" x2="245" y2="180"/><line x1="85" y1="95" x2="55" y2="80"/><line x1="85" y1="165" x2="55" y2="180"/><line x1="150" y1="200" x2="150" y2="228"/></g><g font-family="Montserrat,serif" font-size="14" fill="var(--lvp-gold)" opacity="0.7"><text x="146" y="28" text-anchor="middle">O</text><text x="146" y="244" text-anchor="middle">O</text></g></svg>';
  }
  function honeycombBackdrop() {
    var cells = '', size = 30, w = Math.sqrt(3) * size, hh = 1.5 * size;
    for (var row = -1; row < 7; row++) for (var col = -1; col < 6; col++) {
      var cx = col * w + (row % 2 ? w / 2 : 0), cy = row * hh, pts = [];
      for (var i = 0; i < 6; i++) { var a = (Math.PI / 3) * i - Math.PI / 2; pts.push((cx + 26 * Math.cos(a)).toFixed(1) + ',' + (cy + 26 * Math.sin(a)).toFixed(1)); }
      cells += '<polygon points="' + pts.join(' ') + '" fill="currentColor" fill-opacity="0.18" stroke="var(--lvp-cream)" stroke-width="2.5"/>';
    }
    return '<svg viewBox="0 0 320 320" class="lvh-cr__bdsvg" style="color:var(--lvp-gold)">' + cells + '</svg>';
  }
  function backdropOf(name) {
    if (name === 'molecule') return moleculeBackdrop();
    if (name === 'honeycomb') return honeycombBackdrop();
    return '';
  }

  // ---- lab report visual (shared: Schwarzkümmel + Honig) ----
  function labReport(cfg) {
    cfg = cfg || {};
    var seal = cfg.seal || {}, hlLabel = cfg.hlLabel || 'Hervorgehoben';
    var cards = arr(cfg.reports).map(function (r) {
      var hl = !!r.hl;
      return '<div class="lvh-cr__lrcard' + (hl ? ' is-hl' : '') + '">' +
        '<span class="lvh-cr__lrico' + (hl ? ' is-hl' : '') + '">' + svg(IC[r.icon] || IC.file) + '</span>' +
        '<span class="lvh-cr__lrmeta"><span class="t">' + esc(r.title) + (hl ? '<span class="lvh-cr__hlbadge">' + esc(hlLabel) + '</span>' : '') + '</span><span class="m">' + esc(r.meta) + '</span></span>' +
        '<span class="lvh-cr__lrfile' + (hl ? ' is-hl' : '') + '">' + svg(IC.file) + '</span></div>';
    }).join('');
    return '<div class="lvh-cr__lab">' +
      '<div class="lvh-cr__bd">' + backdropOf(cfg.backdrop) + '</div>' +
      '<div class="lvh-cr__seal">' + svg(IC.shield, 'g') + '<span><span class="l1">' + esc(seal.l1) + '</span><span class="l2">' + esc(seal.l2) + '</span></span></div>' +
      '<div class="lvh-cr__lrstack">' + cards + '</div>' +
      '<div class="lvh-cr__cap">' + esc(cfg.caption) + '</div></div>';
  }

  // ---- state-dependent visuals ----
  function datesVisual(story, activeId) {
    var list = arr(story.dates), active = pick(list, activeId);
    var cards = list.map(function (s) {
      var on = s.id === active.id;
      return '<button type="button" class="lvh-cr__dcard' + (on ? ' is-on' : '') + '" data-sub="' + s.id + '">' +
        '<span class="o">' + esc(s.origin) + '</span><span class="n">' + esc(s.name) + '</span><span class="no">' + esc(s.note) + '</span>' +
        '<span class="sz"><b>' + esc(s.size) + '</b> Größe</span>' +
        '<span class="bar"><span style="width:' + s.sugar + '%"></span></span><span class="g">' + s.sugar + ' g Zucker / 100 g</span></button>';
    }).join('');
    return '<div class="lvh-cr__dates"><div class="lvh-cr__dgrid">' + cards + '</div>' +
      '<div class="lvh-cr__cap"><b>' + esc(active.name) + '</b><span> ' + active.kcal + ' kcal · ' + active.sugar + ' g Zucker · ' + esc(active.origin) + '</span></div></div>';
  }
  function safranVisual(story) {
    var max = story.gradeMax || 280;
    var flower = '<svg viewBox="0 0 200 200" class="lvh-cr__flower">' + (function () {
      var s = ''; for (var i = 0; i < 6; i++) { var a = (Math.PI / 3) * i, cx = 100 + 30 * Math.cos(a), cy = 100 + 30 * Math.sin(a); s += '<ellipse cx="' + cx.toFixed(1) + '" cy="' + cy.toFixed(1) + '" rx="42" ry="22" fill="#b491c8" fill-opacity="0.7" transform="rotate(' + (i * 60) + ' ' + cx.toFixed(1) + ' ' + cy.toFixed(1) + ')"/>'; }
      [-12, 0, 12].forEach(function (dx) { s += '<path d="M ' + (100 + dx) + ' 100 Q ' + (100 + dx * 2) + ' 130 ' + (100 + dx * 1.5) + ' 165" stroke="#c8442e" stroke-width="4" stroke-linecap="round" fill="none"/>'; });
      return s + '<circle cx="100" cy="100" r="10" fill="#f7d774"/>';
    })() + '</svg>';
    var rows = arr(story.grades).map(function (g) {
      return '<div class="lvh-cr__grade' + (g.ours ? ' is-ours' : '') + '"><div class="hd"><span class="k">' + esc(g.k) + (g.ours ? '<span class="ours">' + esc(story.gradeOurs || 'Unsere Wahl') + '</span>' : '') + '</span><span class="c">Crocin ' + g.v + '</span></div>' +
        '<div class="bar"><span' + (g.ours ? ' class="ours"' : '') + ' style="width:' + ((g.v / max) * 100).toFixed(0) + '%"></span></div><div class="hint">' + esc(g.hint) + '</div></div>';
    }).join('');
    return '<div class="lvh-cr__safran">' + flower + '<div class="lvh-cr__sinner"><div class="lvh-cr__slabel">' + esc(story.safranLabel) + '</div><div class="lvh-cr__grades">' + rows + '</div>' +
      '<div class="lvh-cr__sstat"><b>' + esc(story.safranStatNum) + '</b><span>' + (story.safranStatTxt || '') + '</span></div></div></div>';
  }
  function herbsVisual(story, activeId) {
    var list = arr(story.herbs), active = pick(list, activeId);
    var chips = list.map(function (h) {
      var on = h.id === active.id;
      return '<button type="button" class="lvh-cr__hchip' + (on ? ' is-on' : '') + '" data-sub="' + h.id + '"' + (on ? '' : ' style="border-left:4px solid ' + h.c + '"') + '>' + esc(h.n) + '</button>';
    }).join('');
    return '<div class="lvh-cr__herbs"><div class="lvh-cr__hhalo" style="background:' + active.c + '"></div>' +
      '<div class="lvh-cr__hhead"><span>' + esc(story.herbsHead || (list.length + ' Wildkräuter')) + '</span><span class="lvh-cr__hbadge"><i style="background:var(--lvp-gold)"></i>' + esc(story.herbsBadge) + '</span></div>' +
      '<div class="lvh-cr__hchips">' + chips + '</div>' +
      '<div class="lvh-cr__hdetail"><span class="dot" style="background:' + active.c + '"></span><span class="meta"><span class="u">Einsatz · ' + esc(active.u) + '</span><span class="n">' + esc(active.n) + '</span><span class="s">' + (story.herbsNote || '') + '</span></span></div></div>';
  }
  function superfoodVisual(story, activeId) {
    var list = arr(story.sf), active = pick(list, activeId);
    var cards = list.map(function (s) {
      var on = s.id === active.id;
      return '<button type="button" class="lvh-cr__sfcard' + (on ? ' is-on' : '') + '" data-sub="' + s.id + '">' +
        '<span class="tag" style="background:' + s.color + '">' + esc(s.tag) + '</span>' +
        '<span class="n">' + esc(s.name) + '</span><span class="su">' + esc(s.sub) + '</span><span class="no">' + esc(s.note) + '</span></button>';
    }).join('');
    return '<div class="lvh-cr__sf"><div class="lvh-cr__slabel">' + esc(story.sfLabel) + '</div><div class="lvh-cr__sfgrid">' + cards + '</div></div>';
  }
  function talbinaVisual(story) {
    var stalks = ''; [60, 250].forEach(function (x) { var g = '<path d="M10 120 L10 0" stroke="#a8843a" stroke-width="2"/>'; for (var k = 0; k < 7; k++) g += '<ellipse cx="' + (10 + (k % 2 ? 7 : -7)) + '" cy="' + (20 + k * 14) + '" rx="6" ry="9" fill="#d4ad53"/>'; stalks += '<g transform="translate(' + x + ' 40)">' + g + '</g>'; });
    return '<div class="lvh-cr__talbina"><svg viewBox="0 0 320 320" class="lvh-cr__bowl"><ellipse cx="160" cy="210" rx="120" ry="22" fill="#1a1a1a" opacity="0.12"/><path d="M50 170 Q160 290 270 170 Z" fill="#e8d6a8" stroke="#7a5418" stroke-opacity="0.3" stroke-width="2"/><ellipse cx="160" cy="170" rx="110" ry="18" fill="#f5e6c0" stroke="#7a5418" stroke-opacity="0.25" stroke-width="2"/><path d="M120 160 Q160 130 200 160" stroke="var(--lvp-gold)" stroke-width="6" fill="none" stroke-linecap="round" opacity="0.8"/>' + stalks + '</svg><div class="lvh-cr__cap"><b>' + esc(story.talbinaCapB) + '</b><span> ' + esc(story.talbinaCapS) + '</span></div></div>';
  }

  // ---- shared bits ----
  var D = {}; // asset fallback urls, filled from dataset
  function sizedUrl(u, w) { if (!u) return u; if (/[?&]width=\d+/.test(u)) return u.replace(/([?&]width=)\d+/, '$1' + w); if (/_\d+x\./.test(u)) return u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; } function imgUrl(o, w) { var u = (o && o.img) || (o && D[o.imgKey]) || D.bundle || ''; return w ? sizedUrl(u, w) : u; }
  function factsHtml(facts) {
    facts = arr(facts);
    return '<dl class="lvh-st__facts">' + facts.map(function (f) { return '<div><dt>' + esc(f[0]) + '</dt><dd>' + esc(f[1]) + '</dd></div>'; }).join('') + '</dl>';
  }
  function chipsHtml(items, activeId) {
    if (!items.length) return '';
    return '<div class="lvh-cr__chips">' + items.map(function (v) {
      return '<button type="button" class="lvh-cr__chip' + (v.id === activeId ? ' is-on' : '') + '" data-sub="' + v.id + '">' + esc(v.label) + '</button>';
    }).join('') + '</div>';
  }
  function productHtml(p) {
    return '<a href="' + (p.href || '#') + '" class="lvh-st__prod" aria-label="' + esc(p.label) + '"><img src="' + imgUrl(p, 160) + '" srcset="' + imgUrl(p, 80) + ' 80w, ' + imgUrl(p, 160) + ' 160w, ' + imgUrl(p, 240) + ' 240w" sizes="70px" width="70" height="70" alt="' + esc(p.label) + '" loading="lazy"><span class="meta"><span class="pre">Sunnafrucht®</span><span class="nm">' + esc(p.label) + '</span></span>' + svg(IC.arrow) + '</a>';
  }
  function sfChip(name) {
    var w = String(name || '').split(' ');
    return (w[0] === 'Bio' && w[1]) ? w[1] : (w[0] || name);
  }

  // build a story's visual + facts + product for a given sub-state
  function build(story, sub) {
    var kind = story.kind || 'plain';
    var base = story.product || {};
    var visual = '', facts = story.facts, product = base, chips = '';

    // if (kind === 'dates' && arr(story.dates).length) {
    //   var d = pick(story.dates, sub);
    //   visual = datesVisual(story, d.id);
    //   // product = { img: base.img, imgKey: base.imgKey, href: base.href, label: (story.subPrefix || '') + d.name + (story.subSuffix || '') };
    //   product = { img: base.img, imgKey: base.imgKey, href: d.href || base.href, label: (story.subPrefix || '') + d.name + (story.subSuffix || '') };
    if (kind === 'dates' && arr(story.dates).length) {
    var d = pick(story.dates, sub);
    visual = datesVisual(story, d.id);
    product = { img: d.img || base.img, imgKey: base.imgKey, href: d.href || base.href, label: (story.subPrefix || '') + d.name + (story.subSuffix || '') };
    } else if (kind === 'herbs' && arr(story.herbs).length) {
      var hb = pick(story.herbs, sub);
      visual = herbsVisual(story, hb.id);
      // product = { img: base.img, imgKey: base.imgKey, href: base.href, label: (story.subPrefix || '') + hb.n + (story.subSuffix || '') };
      // product = { img: base.img, imgKey: base.imgKey, href: hb.href || base.href, label: (story.subPrefix || '') + hb.n + (story.subSuffix || '') };
      product = { img: hb.img || base.img, imgKey: base.imgKey, href: hb.href || base.href, label: (story.subPrefix || '') + hb.n + (story.subSuffix || '') };
    } else if (kind === 'superfood' && arr(story.sf).length) {
      var s = pick(story.sf, sub);
      visual = superfoodVisual(story, s.id);
      facts = arr(s.facts).length ? s.facts : story.facts;
      product = { img: s.img, imgKey: s.imgKey || base.imgKey, href: s.href || base.href, label: s.name };
      chips = chipsHtml(story.sf.map(function (x) { return { id: x.id, label: sfChip(x.name) }; }), s.id);
    } else if (kind === 'safran') {
      visual = safranVisual(story);
    } else if (kind === 'talbina') {
      visual = talbinaVisual(story);
    } else { // lab / plain
      visual = labReport(story.lab);
      if (arr(story.variants).length) {
        var v = pick(story.variants, sub);
        facts = arr(v.facts).length ? v.facts : story.facts;
        product = { img: v.img, imgKey: v.imgKey || base.imgKey, href: v.href || base.href, label: v.plabel || base.label };
        chips = chipsHtml(story.variants, v.id);
      }
    }

    var cls = 'lvh-st__shell'
      + ' lvh-st__shell--' + (slug(story.label) || 'tab')
      + ' lvh-st__shell--' + kind
      + (sub ? ' lvh-st__shell--sub-' + slug(sub) : '');

    return '<div class="' + cls + '">' +
      '<div class="lvh-st__visual lvh-cr__visual">' + visual + '</div>' +
      '<div class="lvh-st__bodywrap">' + chips + productHtml(product) +
      '<span class="lvh-eyebrow lvh-st__eyebrow">' + esc(story.eyebrow) + '</span>' +
      '<h3 class="lvh-st__h3">' + (story.title || '') + '</h3>' +
      '<p class="lvh-st__text">' + esc(story.body) + '</p>' + factsHtml(facts) +
      '<a href="' + (story.href || '#') + '" class="lvh-st__cta">' + esc(story.cta) + svg(IC.arrow) + '</a></div></div>';
  }

  function initOne(root) {
    if (root._crInit) return; root._crInit = true;
    D = { hero: root.dataset.hero, pour: root.dataset.pour, seeds: root.dataset.seeds, bundle: root.dataset.bundle, honey: root.dataset.honey, dates: root.dataset.dates, herbs: root.dataset.herbs };

    var dataEl = root.querySelector('[data-cr-data]');
    var stories = [];
    try { stories = JSON.parse(dataEl.textContent) || []; } catch (e) { stories = []; }
    stories = stories.filter(function (s) { return s && s.label; });

    var tabsEl = root.querySelector('[data-cr-tabs]');
    var panelEl = root.querySelector('[data-cr-panel]');
    if (!tabsEl || !panelEl) return;
    if (!stories.length) { tabsEl.innerHTML = ''; panelEl.innerHTML = ''; return; }

    var activeTab = 0, subState = {};
    function firstSub(st) {
      if (st.kind === 'dates' && arr(st.dates).length) return st.dates[0].id;
      if (st.kind === 'herbs' && arr(st.herbs).length) return st.herbs[0].id;
      if (st.kind === 'superfood' && arr(st.sf).length) return st.sf[0].id;
      if (arr(st.variants).length) return st.variants[0].id;
      return null;
    }
    function renderTabs() {
      tabsEl.innerHTML = stories.map(function (s, i) {
        return '<label class="lvh-st__tab' + (i === activeTab ? ' is-on' : '') + '" data-tab="' + i + '"><span class="lab">' + esc(s.label) + '</span><span class="sub">' + esc(s.sub) + '</span></label>';
      }).join('');
    }
    function renderPanel() {
      var st = stories[activeTab];
      if (!(activeTab in subState)) subState[activeTab] = firstSub(st);
      panelEl.className = 'lvh-cr__panel lvh-cr__panel--' + (slug(st.label) || 'tab') + ' lvh-cr__panel--' + (st.kind || 'plain');
      panelEl.innerHTML = build(st, subState[activeTab]);
    }
    renderTabs(); renderPanel();

    tabsEl.addEventListener('click', function (e) {
      var t = e.target.closest('[data-tab]'); if (!t) return;
      activeTab = +t.dataset.tab; renderTabs(); renderPanel();
    });
    panelEl.addEventListener('click', function (e) {
      var s = e.target.closest('[data-sub]'); if (!s) return;
      e.preventDefault(); subState[activeTab] = s.dataset.sub; renderPanel();
    });
    // herbs hover-select
    panelEl.addEventListener('mouseover', function (e) {
      var s = e.target.closest('.lvh-cr__hchip[data-sub]'); if (!s) return;
      if (subState[activeTab] === s.dataset.sub) return;
      subState[activeTab] = s.dataset.sub; renderPanel();
    });
  }

  function boot(scope) { (scope || document).querySelectorAll('[data-lvh-craft]').forEach(initOne); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
